module.exports = __webpack_public_path__ + "static/47invgde-dbe37ca90e15e54f66a76330b3bb0620.gif";